import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3154, { U3154ROLES } from './U3154';
import U3154PaymentTypeList from './components/U3154PaymentTypeList';
import U3154PaymentTypeForm from './components/U3154PaymentTypeForm';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3154Routes: RouteObject[] = [
  {
    path: 'U3154',
    element: <U2000RequireRole allowedRoles={[U3154ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3154 />,
        children: [
          { index: true, element: <U3154PaymentTypeList /> },
          { path: ':id', element: <U3154PaymentTypeForm /> },
        ],
      },
    ],
  },
];

export default U3154Routes;
